module.exports = __webpack_public_path__ + "img/arvsfonden-logotyp-rgb-svart.2cdb43a3.png";